import { set, toggle } from '@/utils/vuex'
import _ from 'lodash';

export default {
    setDrawer: (state, payload) => {
        state.drawer = payload;
        window.localStorage.setItem("drawer", payload);
    },
    setImage: set("image"),
    setColor: set("color"),
    setLoaderShow: set("loaderShow"),
    setLoaderText: set("loaderText"),
    clearLoaderQueue: (state) => state["loaderQueue"] = [],
    setLoaderQueue: (state, payload) => {
        state.loaderQueue.push(payload)
    },
    unsetLoaderQueue: (state, payload) => {
        state.loaderQueue = state.loaderQueue.filter(q => q != payload);
    },
    toggleDrawer: toggle("drawer"), 
    setUser: set("user"),
    setUserName: set("userName"),
    setUserCountry: set("userCountry"),
    setPageNotFoundDescription: set("pageNotFoundDescription"),
    setMessageBox: set("messageBox"),
    setConfirmDialog: set("confirmDialog"),
    setSnackbar: set("snackbar"),
    setErrors: set("errorMessageBox"),
    setIsAuthenticated: set("isAuthenticated"),
    setDocuments: set("documents")       
}
